import { render, staticRenderFns } from "./SectionFooter.vue?vue&type=template&id=4c38bc75&"
import script from "./SectionFooter.vue?vue&type=script&lang=js&"
export * from "./SectionFooter.vue?vue&type=script&lang=js&"
import style0 from "./SectionFooter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports